/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface HistoryDescription { 
    title: string;
    list?: Array<string>;
    titleHtml?: string;
    listHtml?: Array<string>;
}

